import { gql } from '@/apollo';

export const GET_SYSTEM_HEALTH = gql`
  query GetSystemHealth {
    systemHealth {
      memory {
        used
        total
        percentage
        available
      }
      cpu {
        percentage
        loadAverage
        cores
      }
      disk {
        used
        total
        percentage
        available
      }
      network {
        bytesPerSecond
        packetsPerSecond
        connectionsActive
      }
      timestamp
    }
  }
`;

export const GET_SERVER_HEALTH_STATUS = gql`
  query GetServerHealthStatus {
    serverHealthStatus {
      healthy
      details
    }
  }
`;

export const RESTART_SERVER = gql`
  mutation RestartServer {
    restartServer {
      success
      message
      details
    }
  }
`;

export const OPTIMIZE_DATABASE = gql`
  mutation OptimizeDatabase {
    optimizeDatabase {
      success
      message
      details
    }
  }
`;

export const BACKUP_DATABASE = gql`
  mutation BackupDatabase($backupId: String) {
    backupDatabase(backupId: $backupId) {
      success
      message
      details
      backupId
    }
  }
`;

export const GET_BACKUP_PROGRESS = gql`
  query GetBackupProgress($backupId: String!) {
    backupProgress(backupId: $backupId) {
      id
      status
      progress
      message
      filePath
      fileSize
      createdAt
    }
  }
`;

export const DOWNLOAD_BACKUP = gql`
  mutation DownloadBackup($backupId: String!) {
    downloadBackup(backupId: $backupId)
  }
`;

export const CLEAR_CACHE = gql`
  mutation ClearCache {
    clearCache {
      success
      message
      details
    }
  }
`;
